import { h, Component } from 'preact';
import { Router } from 'preact-router';

import { connect, observer, Provider } from 'mobx-preact';

//import { connect } from 'mobx-preact'

import initState from '../state/initState';
import Header from './header';
import Home from '../routes/home';

import chatStore from '../state/chatStore';

// const Root = () => <App ChatStore={ChatStore} />;

// export default Root;



export default class App extends Component {
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */

	constructor () {
		super();
		this.state = {
			authenticated: false,
		};
	}

    componentDidMount () {
		console.log('componentDidMount chatStore: ', chatStore);
		initState(chatStore);
	}

	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Header />
				<Provider chatStore={chatStore}>
					<Router>
						<Home path="/" />
					</Router>
				</Provider>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./components/app.js